import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HomeContent from "@/components/HomeContent.vue";

export default /*#__PURE__*/_defineComponent({
  name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(HomeContent)
  ]))
}
}

})